<label class="container">
    <p class="check-text"><ng-content></ng-content></p>
    <input #checkbox type="checkbox" [name]="name" (change)="onChange(checkbox.checked)">
    <span class="checkmark"></span>
  </label>